import React from 'react';
import { Section } from './ui/Section';
import { XCircle } from 'lucide-react';
export function OldSolutionsSection() {
  return <Section background="white" data-id="element-135">
      <h2 className="text-3xl font-serif font-bold text-slate-900 mb-8 text-center" data-id="element-136">
        Por qué lo que ya intentaste no te sostuvo
      </h2>

      <div className="grid gap-4" data-id="element-137">
        {['Te dijeron “higiene del sueño”… como si fuera lo mismo a los 25 y a los 45.', 'Probaste té, melatonina, videos, meditaciones… y a veces ayudan, pero no siempre.', 'Intentaste “pensar positivo” mientras tu cuerpo está en alerta.', 'Dejaste tu cuarto “más o menos” oscuro/fresco… y ese “más o menos” te despierta.'].map((item, index) => <div key={index} className="flex items-start gap-3 p-4 rounded-lg bg-red-50/50" data-id="element-138">
            <XCircle className="w-5 h-5 text-red-400 flex-shrink-0 mt-0.5" data-id="element-139" />
            <p className="text-slate-700" data-id="element-140">{item}</p>
          </div>)}
      </div>

      <div className="mt-10 text-center" data-id="element-141">
        <p className="text-lg text-slate-600" data-id="element-142">
          Y cuando nada funciona, haces lo humano: <strong data-id="element-143">te culpas.</strong>
        </p>
        <p className="text-xl font-bold text-slate-900 mt-2" data-id="element-144">
          Pero tu problema no es moral. Es de diseño.
        </p>
      </div>
    </Section>;
}